module.exports = __webpack_public_path__ + "img/client_muzieum.f26dc22c.png";